import { gql } from '@apollo/client';

export const GET_FEEDBACK = gql`
  query GetFeedback($id: ID!) {
    node(id: $id) {
      ... on OpportunityNode {
        id
        icbFeedbackId {
          id
          stage
          commentary
          assumptions
          reviewQuestionIds {
            id
            question
            answer
            createUid {
              name
            }
            createDate
          }
        }
        rsmFeedbackId {
          id
          stage
          commentary
          assumptions
          reviewQuestionIds {
            id
            question
            answer
            createUid {
              name
            }
            createDate
          }
        }
      }
    }
  }
`;

export const UPDATE_DEAL_OPPORTUNITY_REVIEW = gql`
  mutation UpdateDealOpportunityReview(
    $values: DealOpportunityCommentaryInput!
  ) {
    updateDealOpportunityReview(values: $values) {
      ok
      errors
      dealOpportunityReview {
        id
        stage
        commentary
        assumptions
      }
    }
  }
`;

export const CREATE_REVIEW_QUESTION = gql`
  mutation CreateDealOpportunityReviewQuestion(
    $values: DealOpportunityCommentaryQuestionCreateInput!
  ) {
    createDealOpportunityReviewQuestion(values: $values) {
      ok
      errors
      dealOpportunityReviewQuestion {
        id
        question
        answer
      }
    }
  }
`;

export const UPDATE_REVIEW_QUESTION = gql`
  mutation UpdateDealOpportunityReviewQuestion(
    $id: ID!
    $values: DealOpportunityCommentaryQuestionUpdateInput!
  ) {
    updateDealOpportunityReviewQuestion(id: $id, values: $values) {
      ok
      errors
      dealOpportunityReviewQuestion {
        id
        question
        answer
      }
    }
  }
`;

export const DELETE_REVIEW_QUESTION = gql`
  mutation DeleteDealOpportunityReviewQuestion(
    $id: ID!
    $values: DeleteDealOpportunityCommentaryQuestionInput!
  ) {
    deleteDealOpportunityReviewQuestion(id: $id, values: $values) {
      ok
      errors
    }
  }
`;

export interface CreateReviewQuestionResponse {
  createDealOpportunityReviewQuestion: {
    dealOpportunityReviewQuestion: {
      answer: null | string;
      id: string;
      question: null | string;
    } | null;
    errors: string[];
    ok: boolean;
  };
}

export interface DealOpportunityCommentaryInput {
  assumptions?: string;
  commentary?: string;
  opportunityId: string;
  questionIds?: string[];
  stage: string;
}

export interface DealOpportunityCommentaryQuestionCreateInput {
  answer?: string;
  opportunityId: string;
  question: string;
  stage: string;
}

export interface DealOpportunityCommentaryQuestionUpdateInput {
  answer?: string;
  opportunityId: string;
  question: string;
  stage: string;
}

export interface DeleteDealOpportunityCommentaryQuestionInput {
  opportunityId: string;
  stage: string;
}

export interface DeleteReviewQuestionResponse {
  deleteDealOpportunityReviewQuestion: {
    errors: string[];
    ok: boolean;
  };
}

export interface FeedbackReview {
  assumptions: null | string;
  commentary: null | string;
  id: string;
  reviewQuestionIds: ReviewQuestion[];
  stage: null | string;
}

export interface GetFeedbackResponse {
  node: {
    __typename: 'OpportunityNode';
    icbFeedbackId: FeedbackReview | null;
    id: string;
    rsmFeedbackId: FeedbackReview | null;
  } | null;
}

export interface ReviewQuestion {
  answer: null | string;
  createDate: null | string;
  createUid: { name: null | string } | null;
  id: string;
  question: null | string;
}

export interface UpdateDealOpportunityReviewResponse {
  updateDealOpportunityReview: {
    dealOpportunityReview: {
      assumptions: null | string;
      commentary: null | string;
      id: string;
      stage: null | string;
    } | null;
    errors: string[];
    ok: boolean;
  };
}

export interface UpdateReviewQuestionResponse {
  updateDealOpportunityReviewQuestion: {
    dealOpportunityReviewQuestion: {
      answer: null | string;
      id: string;
      question: null | string;
    } | null;
    errors: string[];
    ok: boolean;
  };
}

export const formatDate = (dateString: null | string | undefined): string => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};
